import React, {Component} from 'react';
import './App.css';
import Wishes from './Wishes';

import buttonWish from './img/button_ornament.png';




                                                /* //////////////////////////
                                                ID & RESET HANDLE
                                                ///////////////////////////*/ 

    class MakeWish extends Component{
        constructor(props){
            super(props);
           this.resetStates = this.resetStates.bind(this);
        }


    resetStates(){
        Wishes();
    }

        render() {

            return (

              
                <div className="buttonWrapper">
         
                <img onClick={this.resetStates} className="button buttonImg" src={buttonWish} alt="button"></img>
                </div>
               
               
                    
            )
        } 
    }

    export default MakeWish;